import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import * as API from '../../../api';
import { ApiResponse } from '../../../api/ApiClient';
import { IAlert, IApiList } from '../../../types';
import * as Actions from './actions';
import * as ActionTypes from './types';

export function* getUserAlerts(): any {
  try {
    const response: ApiResponse<IApiList<IAlert>> = yield call(API.Users.listAlerts, { sort: '-created_at', limit: 1 });

    yield put(Actions.getUserAlertsSuccess(response.body));
  } catch (error: any) {
    yield put(Actions.getUserAlertsError(error));
  }
}

export function* watchGetUserAlerts() {
  yield takeEvery(ActionTypes.Alerts.GET_USER_ALERTS_REQUEST, getUserAlerts);
}

function* alertsSaga() {
  yield all([fork(watchGetUserAlerts)]);
}
export { alertsSaga };
